import { Subject } from 'rxjs';
import { Chart, registerables } from 'chart.js';
import { ChartModel } from './../../models/azure-dashboard-view.model';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ReportingService } from '../../services/reporting.service';
import { FileService } from '../../services/file.service';
import { NgProgress } from 'ngx-progressbar';
import { CurrentUsageTenantSummaryModel, TenantUsageSummary } from '../../models/azure-dashboard-view.model';
import { Sort } from '@angular/material/sort';
import { NgbCalendar, NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../services';
import { CurrentUserModel } from '../../models/account-ledger.model';
import { AuthService } from '../../services/auth.service';
import * as moment from 'moment';
import { NgProgressService } from '../../services/ngProgress.service';
import { takeUntil } from 'rxjs/operators';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { getDate, getMonth } from 'date-fns';
import { DatePipe } from '@angular/common';


declare var $: any;

@Component({
  selector: 'app-azure-reporting-dashboard',
  templateUrl: './azure-reporting-dashboard.component.html',
  styleUrls: ['./azure-reporting-dashboard.component.css'],
  providers: [DatePipe]
})
export class AzureReportingDashboardComponent implements OnInit, OnDestroy {

  @ViewChild('chartUsageByCategory', { static: false }) chartUsageByCategory: ElementRef;
  @ViewChild('chartUsageByTenants', { static: false }) chartUsageByTenants: ElementRef;

  title = 'Azure Usage Reports';

  reportType = '';
  firstDayOfCurrentMonth = '';
  fromDate: NgbDate;
  toDate: NgbDate;
  fromDateArchive: NgbDate;
  toDateArchive: NgbDate;
  startDateArchive: NgbDate;
  endDateArchive: NgbDate;

  fromCurrentFilter1 : NgbDate
  endDateArchive1: NgbDate;
  //endDateArchive1 = '';
  strDateFrom = '';
  strDateTo = '';
  strDateFromArchive = '';
  strDateToArchive = '';
  lastMonth = '';
  currentType = 'B';
  subTitle = '';
  searchField = '';
  currentUser: CurrentUserModel;
  minDate: Date;
  minDateFilter :NgbDateStruct; 
  maxDate: Date;
  maxDateFilter : NgbDateStruct;
  // export excel
  url: string;

  // charts
  pieChart: any;
  doughnutChart: any;

  showPager = false;
  isCurrentUsage = false;
  isHistorical = false;
  isUnbilledLastMonth = false;
  isEstimatedUsage = false;
  isCurrentUsageMicrosoft = false;
  loadingFinished = false;
  loadContent = false;
  isArchive:boolean = false;
  // ngUnsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();

  summaryModel: CurrentUsageTenantSummaryModel;
  tenantList: TenantUsageSummary[] = [];
  sortedData: TenantUsageSummary[] = [];
  tenantChartData: ChartModel[] = [];
  categoryChartData: ChartModel[] = [];
  chartTenantLabels: string[] = [];
  chartTenantValues: string[] = [];
  chartCategoryLabels: string[] = [];
  chartCategoryValues: string[] = [];
  backgroundColors: string[] = [
    '#C20047',
    '#437EB4',
    '#fef77b',
    '#660066',
    '#800000',
    '#E1FCFF',
    '#ffc500',
    '#84BF84',
    '#F08080',
    '#0E6655',
    '#ff33ff',
    '#86b300',
    '#4d0099',
    '#00cc99',
    '#ff704d',
    '#0000b3',
    '#66a3ff',
    '#ffcc80',
    '#7575a3',
    '#408000',
    '#00ff99',
    '#b32d00',
    '#ff0066',
    '#4db8ff',
    '#ffff80',
    '#cc0000',
    '#8080ff'
  ];

  types: any[] = [
    // { value: 'UNBILLED USAGE - MICROSOFT', id: 'M' },
    // { value: 'UNBILLED USAGE', id: 'U' },
    // { value: 'UNBILLED - LAST MONTH', id: 'L' },
    { value: 'BILLED USAGE', id: 'B' }
  ];
  selectedType: string;
  

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private calendar: NgbCalendar,
    private reportingService: ReportingService,
    private commonService: CommonService,
    private fileService: FileService,
    public ngProgress: NgProgressService,
    private authService: AuthService,
    private datePipe: DatePipe
  ) {
    Chart.register(...registerables);    
    //this.minDate = moment().subtract(4, 'month').endOf('month').toDate();   
    this.minDate = new Date(2024, 5, 1, 12, 0);  // Date(year, month, day, hours, minutes)
    this.minDateFilter = {day: this.minDate .getDate(),month : this.minDate.getMonth()+1 , year: this.minDate .getFullYear()}
    this.maxDate = new Date(2024, 4, 31, 12, 0); // Date(year, month, day, hours, minutes)
    this.maxDateFilter = {day: this.maxDate .getDate(),month : this.maxDate.getMonth()+1 , year: this.maxDate .getFullYear()}
  }

  sortData(sort: Sort) {
    const data = this.tenantList.slice();

    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'tenantName': return compare(a.tenantName.toLowerCase(), b.tenantName.toLowerCase(), isAsc);
        case 'nextBillingDate': return compare(a.nextBillingDate.toLowerCase(), b.nextBillingDate.toLowerCase(), isAsc);
        case 'noOfDaysUntilBillingDate': return compare(a.noOfDaysUntilBillingDate.toLowerCase(), b.noOfDaysUntilBillingDate.toLowerCase(), isAsc);
        case 'currentUsageTotal': return compare(parseFloat(a.currentUsageTotal), parseFloat(b.currentUsageTotal), isAsc);
        case 'estimatedUsageTotal': return compare(parseFloat(a.estimatedUsageTotal), parseFloat(b.estimatedUsageTotal), isAsc);
        case 'subscriptionId': return compare(a.subscriptionID.toLowerCase(), b.subscriptionID.toLowerCase(), isAsc);
        case 'subscriptionName': return compare(a.subscriptionName.toLowerCase(), b.subscriptionName.toLowerCase(), isAsc);
        default: return 0;
      }
    });
  }

  ngOnInit() {
    // this.authService.getLoginInfo().subscribe((model: CurrentUserModel) => {
    //   if (model.isStaffAccount || model.isImpersonated) {
    //     this.types = [...this.types, { value: 'ESTIMATED DOWNLOAD', id: 'E' }]
    //   }
    // },
    //   (error: any) => {
    //     console.error(error);
    //   });


    const today = new Date();
    const lastDay = new Date(today.getFullYear(), today.getMonth(), 0);
    this.selectedType = 'B';
    const startDate = moment().subtract(1, 'month').startOf('month').toDate(); // last month first day
    const endDate = moment().subtract(1, 'month').endOf('month').toDate(); // last month last day 

    /* const startDate = moment().subtract(3, 'month').startOf('month').toDate(); // last month first day
    const endDate = moment().subtract(3, 'month').endOf('month').toDate(); // last month last day */

    const startDateArchive = moment().subtract(4, 'month').startOf('month').toDate(); // last 4 months first day
    const endDateArchive = moment().subtract(4, 'month').endOf('month').toDate(); // last 4 months last day
   
    this.fromDate = new NgbDate(startDate.getFullYear(),
      startDate.getMonth() + 1,
      startDate.getDate());
    this.toDate = new NgbDate(endDate.getFullYear(),
      endDate.getMonth() + 1,
      endDate.getDate());         
    
    //Archive Dates

    this.fromDateArchive = new NgbDate (2024,5,1);
    this.toDateArchive = new NgbDate(2024, 5, 31); 
    
    /*  this.fromDateArchive = new NgbDate(startDateArchive.getFullYear(),
      startDateArchive.getMonth() + 1,
      startDateArchive.getDate()); 
     this.toDateArchive = new NgbDate(endDateArchive.getFullYear(),
      endDateArchive.getMonth() + 1,
      endDateArchive.getDate()); */        
     
    this.firstDayOfCurrentMonth = '1/' + (today.getMonth() + 1) + '/' + today.getFullYear();
    this.ngProgress.start();
    this.loadingFinished = false;
    this.loadContent = false;
    this.lastMonth = this.GetMonthName(today.getMonth() - 1);

    this.isCurrentUsage = false;

    // this.getAzureCurrentUsageTenantSummary(true);
    this.selectType();
    this.ngProgress.done();
  }

  downloadEvent() {
    if (this.isCurrentUsage) {
      this.download_UnbilledReports();
    }
      else if(this.isArchive == true){
        this.exportHistoricalUsageReportArchive();
      
    } else if (this.isHistorical || this.isEstimatedUsage) {
      this.downloadReports();
    }
  }

  getAzureCurrentUsageTenantSummary(isLastMonth: boolean): void {
    // load the category chart data first
    // this.getAzureCurrentUsageResourceSummary();
    this.reportingService.getAzureCurrentUsageTenantSummary(isLastMonth).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: CurrentUsageTenantSummaryModel) => {
        this.summaryModel = value;
        this.tenantList = value.tenantList;
        if (this.tenantList) { this.sortedData = this.tenantList.slice(); }
        this.tenantChartData = value.chatData;
        this.loadingFinished = true;

        // if (this.tenantList.length > 20)
        //     this.showPager = true;

        if (this.tenantChartData.length) {
          // this.tenantChartData = this.caculatePercentage(this.tenantChartData);

          this.tenantChartData.forEach(x => {
            this.chartTenantLabels.push(x.name);
            this.chartTenantValues.push(x.value);
          });
        }

        let title = `USAGE AMOUNT BY TENANTS - UNBILLED`;
        if (isLastMonth) {
          title = `USAGE AMOUNT BY TENANTS - UNBILLED LAST MONTH`;
        }

        this.initializePieChart(this.chartUsageByTenants, title, this.chartTenantLabels, this.chartTenantValues);


      },
        (error: any) => {
          console.error(error);
          this.loadingFinished = true;
          this.ngProgress.done();
        });
  }

  getAzureEstimatedTenantSummary(): void {
    this.convertDateFormat();

    // load the category chart data first
    // this.getAzureCurrentUsageResourceSummary();
    this.reportingService.getAzureEstimatedTenantSummary(this.strDateFrom, this.strDateTo).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: CurrentUsageTenantSummaryModel) => {

        this.tenantList = value.tenantList;

        if (this.tenantList) {
          this.sortedData = this.tenantList.slice();
        }

        this.loadingFinished = true;

        // if (this.tenantList.length > 20)
        //     this.showPager = true;



        const title = `ESTIMATED REPORT`;

      },
        (error: any) => {
          console.error(error),
            this.ngProgress.done();
        });
  }
  getAzureEstimatedTenantSummaryArchive(): void {
    this.convertDateFormat();

    // load the category chart data first
    // this.getAzureCurrentUsageResourceSummary();
    this.reportingService.getAzureEstimatedTenantSummaryArchive(this.strDateFromArchive, this.strDateToArchive).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: CurrentUsageTenantSummaryModel) => {

        this.tenantList = value.tenantList;

        if (this.tenantList) {
          this.sortedData = this.tenantList.slice();
        }

        this.loadingFinished = true;

        // if (this.tenantList.length > 20)
        //     this.showPager = true;



        const title = `ESTIMATED REPORT`;

      },
        (error: any) => {
          console.error(error),
            this.ngProgress.done();
        });
  }

  GetMonthName(monthNumber): string {
    const months = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];
    return months[monthNumber];
  }

  getAzureCurrentUsageResourceSummary(): void {
    this.reportingService.getAzureCurrentUsageResourceSummary().pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: ChartModel[]) => {
        this.categoryChartData = value;

        if (this.categoryChartData.length) {
          // this.categoryChartData = this.caculatePercentage(this.categoryChartData);
          // push values into empty chart arrays
          this.categoryChartData.forEach(x => {
            this.chartCategoryLabels.push(x.name);
            this.chartCategoryValues.push(x.value);
          });
        }

        const title = `CURRENT USAGE AMOUNT BY CATEGORY - UNBILLED`;
        this.initializeDoughnutChart(this.chartUsageByCategory, title, this.chartCategoryLabels, this.chartCategoryValues);
      },
        (error: any) => {
          console.error(error);
          this.ngProgress.done();
        });
  }

  getAzureHistoricalUsageSummary(): void {
    this.convertDateFormat();

    // this.reportingService.getAzureTopUsageTenants(this.strDateFrom, this.strDateTo).takeUntil(this.ngUnsubscribe)
    //    .subscribe((value: ChartModel[]) => {

    //      if (value.length > 0) {

    //       //let newValue = this.caculatePercentage(value);

    //       value.forEach(x => {
    //           this.chartTenantLabels.push(x.name);
    //           this.chartTenantValues.push(x.value);
    //         })

    //         const title = `USAGE AMOUNT FROM ${this.strDateFrom} TO ${this.strDateTo} - TOP 20 TENANTS`;
    //         this.initializePieChart("chartUsageByTenants", title, this.chartTenantLabels, this.chartTenantValues);
    //       }

    //    },
    //    (error: any) => {
    //     console.info(error);
    //     this.ngProgress.done();
    //    });

    //  this.reportingService.getAzureTopUsageResources(this.strDateFrom, this.strDateTo).takeUntil(this.ngUnsubscribe)
    //     .subscribe((value: ChartModel[]) => {

    //       if (value.length > 0) {
    //         //const newValue = this.caculatePercentage(value);

    //         value.forEach(x => {
    //            this.chartCategoryLabels.push(x.name);
    //            this.chartCategoryValues.push(x.value);
    //          })

    //          const title = `USAGE AMOUNT FROM ${this.strDateFrom} TO ${this.strDateTo} - TOP 20 CATEGORY`;
    //          this.initializeDoughnutChart("chartUsageByCategory",title, this.chartCategoryLabels, this.chartCategoryValues);
    //        }
    //     },
    //     (error: any) => {
    //       console.info(error);
    //       this.ngProgress.done();
    //      });
    this.reportingService.getAzureUsageSummary(this.strDateFrom, this.strDateTo).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: TenantUsageSummary[]) => {
        this.tenantList = value;
        if (this.tenantList) {
          this.sortedData = this.tenantList.slice();
        } else {
          this.sortedData = [];
        }
        this.loadingFinished = true;
      },
        (error: any) => {
          console.error(error);
          this.loadingFinished = true;
          this.ngProgress.done();
        });
  }
  getAzureHistoricalUsageSummaryArchive(): void {
    this.convertDateFormatArchive();    
    this.reportingService.getAzureUsageSummaryArchive(this.strDateFromArchive, this.strDateToArchive).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: TenantUsageSummary[]) => {
        this.tenantList = value;
        if (this.tenantList) {
          this.sortedData = this.tenantList.slice();
        } else {
          this.sortedData = [];
        }
        this.loadingFinished = true;
      },
        (error: any) => {
          console.error(error);
          this.loadingFinished = true;
          this.ngProgress.done();
        });
  }

  initializeDoughnutChart(chart: ElementRef, title: string, labels: string[], values: string[]) {
    const ctx = chart.nativeElement;
    if (this.doughnutChart != undefined) {
      this.doughnutChart.destroy();
    }
    this.doughnutChart = new Chart(ctx, {
      type: 'doughnut',
      data: {
        datasets: [{
          data: values,
          backgroundColor: this.backgroundColors
        }],
        labels: labels
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
            display: false
          },
          title: {
            display: true,
            text: title
          }
        },
        animation: {
          animateScale: true,
          animateRotate: true
        }
      }
    });
  }

  initializePieChart(chart: ElementRef, title: string, labels: string[], values: string[]) {
    const ctx = chart.nativeElement;
    if (this.pieChart != undefined) {
      this.pieChart.destroy();
    }
    this.pieChart = new Chart(ctx, {
      type: 'pie',
      data: {
        datasets: [{
          data: values,
          backgroundColor: this.backgroundColors
        }],
        labels: labels
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
            display: false
          },
          title: {
            display: true,
            text: title
          }
        }
      }
    });
  }

  selectType(): void {
    this.searchField = '';
    this.loadContent = false;
    this.loadingFinished = false;
    // initialize arrays to empty and destroy charts
    this.chartTenantLabels = [];
    this.chartTenantValues = [];
    this.chartCategoryLabels = [];
    this.chartCategoryValues = [];

    this.currentType = this.selectedType;

    // this.pieChart.destroy();
    // this.doughnutChart.destroy();
    switch (this.currentType) {
      case 'M':
        this.getAzureCurrentUsageTenantSummary(false);
        break;
      case 'U':
        this.getAzureCurrentUsageTenantSummary(false);
        break;
      case 'L':
        this.getAzureCurrentUsageTenantSummary(true);
        break;
      case 'B':
        this.getAzureHistoricalUsageSummary();
        break;
      case 'E':
        this.getAzureEstimatedTenantSummary();
        break;
    }

    this.isHistorical = this.currentType === 'B' ? true : false;
    this.isUnbilledLastMonth = this.currentType === 'L' ? true : false;
    this.isCurrentUsage = this.currentType === 'U' ? true : false;
    this.isCurrentUsageMicrosoft = this.currentType === 'M' ? true : false;
    this.isEstimatedUsage = this.currentType === 'E' ? true : false;
  }

  convertDateFormat(): void {
    this.strDateFrom = this.fromDate.day + '/' + this.fromDate.month + '/' + this.fromDate.year;
    this.strDateTo = this.toDate.day + '/' + this.toDate.month + '/' + this.toDate.year;
  }
  convertDateFormatArchive(): void {
    this.strDateFromArchive = this.fromDateArchive.day + '/' + this.fromDateArchive.month + '/' + this.fromDateArchive.year;
    this.strDateToArchive = this.toDateArchive.day + '/' + this.toDateArchive.month + '/' + this.toDateArchive.year;
  }

  

  validateDayRanges(btnName: string): boolean {  
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    const utcFrom = Date.UTC(this.fromDate.year, this.fromDate.month, this.fromDate.day);
    const utcTo = Date.UTC(this.toDate.year, this.toDate.month, this.toDate.day);

    const days = Math.floor((utcTo - utcFrom) / _MS_PER_DAY);  
    if (days > 31) {
      $('#' + btnName).showValidator('Report date range can be maximum of 31 days', 'error', 'right');
      return false;
    }    
    else if (days < 1) {
      $('#' + btnName).showValidator('Invalid date range selected', 'error', 'right');
      return false;
    }

    return true;
  }

  validateDayRangesArchive(btnName: string): boolean {
   
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;  

    const utcFrom = Date.UTC(this.fromDateArchive.year, this.fromDateArchive.month, this.fromDateArchive.day);
    const utcTo = Date.UTC(this.toDateArchive.year, this.toDateArchive.month, this.toDateArchive.day);

    const days = Math.floor((utcTo - utcFrom) / _MS_PER_DAY);    

    if(days >31)    
    {    
      $('#' + btnName).showValidator('Report date range can be maximum of 31 days', 'error', 'right');
      return false;
    }  
    else if (days < 1) {
      $('#' + btnName).showValidator('Invalid date range selected', 'error', 'right');
      return false;
    }
    
    return true;
    
  }

  caculatePercentage(data: ChartModel[]): ChartModel[] {
    const total = data.map(i => parseFloat(i.value)).reduce((prev, next) => prev + next);

    data.forEach(a => {
      a.value = ((parseFloat(a.value) / total) * 100).toString() + '%';
    });

    return data;
  }

  filterReports(): void {
    // debugger;
    const isValid = this.validateDayRanges('btnFilter');

    if (!isValid) { return; }

    // this.ngProgress.start();
    this.loadContent = false;
    // initialize arrays to empty and destroy charts
    this.chartTenantLabels = [];
    this.chartTenantValues = [];
    this.chartCategoryLabels = [];
    this.chartCategoryValues = [];

    // this.pieChart.destroy();
    // this.doughnutChart.destroy();
    if (this.currentType === 'B') {
      this.getAzureHistoricalUsageSummary();
    } else if (this.currentType === 'E') {
      this.getAzureEstimatedTenantSummary();
    }
  }

  filterReportsArchive(): void {
    // debugger;
    const isValid = this.validateDayRangesArchive('btnFilter');

    if (!isValid) { return; }

    // this.ngProgress.start();
    this.loadContent = false;
    // initialize arrays to empty and destroy charts
    this.chartTenantLabels = [];
    this.chartTenantValues = [];
    this.chartCategoryLabels = [];
    this.chartCategoryValues = [];

    // this.pieChart.destroy();
    // this.doughnutChart.destroy();
    if (this.currentType === 'B') {
      this.getAzureHistoricalUsageSummaryArchive();
    } else if (this.currentType === 'E') {
      this.getAzureEstimatedTenantSummaryArchive();
    }
  }


  downloadReports(): void {
    const isValid = this.validateDayRanges('btnDownload');
    if (!isValid) { return; }
    this.ngProgress.start();
    // $('#btnDownload').showValidator('Usage report will be downloaded shortly', 'success');
    this.commonService.implementToast('Azure usage report will be downloaded shortly', 'Info');

    if (this.currentType === 'B') {
      this.exportHistoricalUsageReport();
    } 
    else if(this.isArchive == true){
      this.exportHistoricalUsageReportArchive();
    }
      else if (this.currentType === 'E') {
      this.exportEstimatedUsageReport();
    }


  }
  
  download_UnbilledReports(tenantId?: string, subscriptionId?: string): void {
    this.ngProgress.start();
    tenantId = tenantId === undefined ? '' : tenantId;
    subscriptionId = subscriptionId === undefined ? '' : subscriptionId;
    this.commonService.implementToast('Unbilled usage report will be downloaded shortly', 'Info');

    this.reportingService.exportCurrent_Unbilled_UsageReport(tenantId, subscriptionId, this.isUnbilledLastMonth).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: any) => {
        const fileName = `AzureUsage_${this.isUnbilledLastMonth ? 'Unbilled_LastMonth' : 'Unbilled_Current'}.xlsx`;

        this.fileService.saveAsExcelFile(data, fileName);
        this.ngProgress.done();
        this.commonService.implementToast('Azure unbilled usage report downloaded successfully', 'Success');
      },
        (error: any) => {
          console.error(error);
          this.ngProgress.done();
        });

  }
 
  exportHistoricalUsageReport(subId?: string): void {
    this.ngProgress.start();
    // convert dates before calling service methods
    this.convertDateFormat();

    if (subId) {
      // $(`#downloadBtn${subId}`).showValidator('Usage report will be downloaded shortly', 'success', 'right');
      this.commonService.implementToast('Azure usage report will be downloaded shortly', 'Info');
    } else {
      subId = '';
    }

    this.reportingService.exportHistoricalUsageReport(this.strDateFrom, this.strDateTo, subId).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: any) => {
        const fileName = `AzureUsage_${this.strDateFrom}-${this.strDateTo}.xlsx`;

        this.fileService.saveAsExcelFile(data, fileName);
        this.ngProgress.done();
        this.commonService.implementToast('Azure usage report downloaded successfully', 'Success');
      },
        (error: any) => {
          console.error(error);
          this.ngProgress.done();
        });
  }
  exportHistoricalUsageReportArchive(subId?: string): void {
    this.ngProgress.start();
    // convert dates before calling service methods
    this.convertDateFormat();

    if (subId) {
      // $(`#downloadBtn${subId}`).showValidator('Usage report will be downloaded shortly', 'success', 'right');
      this.commonService.implementToast('Azure usage report will be downloaded shortly', 'Info');
    } else {
      subId = '';
    }

    this.reportingService.exportHistoricalUsageReportArchive(this.strDateFromArchive, this.strDateToArchive, subId).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: any) => {
        const fileName = `AzureUsage_${this.strDateFromArchive}-${this.strDateToArchive}.xlsx`;

        this.fileService.saveAsExcelFile(data, fileName);
        this.ngProgress.done();
        this.commonService.implementToast('Azure usage report downloaded successfully', 'Success');
      },
        (error: any) => {
          console.error(error);
          this.ngProgress.done();
        });
  }
   exportEstimatedUsageReport(tenantId?: string, subscriptionId?: string): void {
    this.ngProgress.start();
    this.convertDateFormat();

    tenantId = tenantId === undefined ? '' : tenantId;
    subscriptionId = subscriptionId === undefined ? '' : subscriptionId;
    this.commonService.implementToast('Estimated usage report will be downloaded shortly', 'Info');

    this.reportingService.export_Estimated_UsageReport(this.strDateFrom, this.strDateTo, tenantId, subscriptionId).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: any) => {
        const fileName = `Estimated_Usage_${subscriptionId}.xlsx`;

        this.fileService.saveAsExcelFile(data, fileName);
        this.ngProgress.done();
        this.commonService.implementToast('Estimated usage report downloaded successfully', 'Success');
      },
        (error: any) => {
          console.error(error);
          this.ngProgress.done();
        });

  } 

  manageRedirect(tenant: TenantUsageSummary): void {
    this.ngProgress.start();
    this.convertDateFormat();

    if (this.isHistorical) {
      this.router.navigate(['azurereportingdetails'], {
        relativeTo: this.activatedRoute,
        queryParams: {
          tenantId: tenant.tenantID,
          subscriptionId: tenant.subscriptionID,
          startDate: this.strDateFrom,
          endDate: this.strDateTo
        },
        skipLocationChange: true
      });

      this.ngProgress.done();
    } else {  // redirect to current usage details page
      this.router.navigate(['azurecurrentusagedetails'], {
        relativeTo: this.activatedRoute,
        queryParams: {
          tenantId: tenant.tenantID,
          subscriptionId: tenant.subscriptionID,
          lastBillingDate: tenant.lastBillingDate,
          nextBillingDate: tenant.nextBillingDate,
          subscriptionName: tenant.subscriptionName
        },
        skipLocationChange: true
      });

      this.ngProgress.done();
    }
  }

  onLoading(currentLoadingStatus: boolean) {

    this.loadContent = !currentLoadingStatus;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  close() {
    // $('.page-contents').animate({ scrollLeft: -$('#levelOne').width() }, 400);
    this.router.navigateByUrl('/reporting');
  }
 
  showArchive(event:any):void  {     
    if (!event.checked) {      
     this.isArchive=event.checked;
    this.filterReports();
    } else {
      this.isArchive=event.checked; 
      this.filterReportsArchive();
    } 
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
